
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import FormModelDisplay from '@/components/FormModelDisplay.vue';
import OrderRepository from '@/repositories/webshop/OrderRepository';
import ProductOrderRepository from '@/repositories/webshop/ProductOrderRepository';

@Component({
    components: {
        GeneralScaffold,
        FormModelDisplay,
    },
})
export default class OrderFormScreen extends Vue {
    @Inject()
    private readonly orderRepository!: OrderRepository;
    @Inject()
    private readonly productOrderRepository!: ProductOrderRepository;

    public get embeds() {
        return [
            {
                relationship: 'productOrders',
                parentRefKey: 'orderId',
                i18nGroup: 'product-order',
                entityRepository: this.productOrderRepository,
                columns: ['defaultName', 'status', 'price', 'amount'],
            },
        ];
    }
}
